import { render, staticRenderFns } from "./Deliverect.vue?vue&type=template&id=0c9517fc"
import script from "./Deliverect.vue?vue&type=script&lang=js"
export * from "./Deliverect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports